// Soft App Store / Play review prompt state (local).

export const LS_REVIEW_PROMPT_KEY = "mmu_review_prompt_v1";

export function loadReviewPromptState() {
    try {
        const raw = window.localStorage.getItem(LS_REVIEW_PROMPT_KEY);
        if (!raw) {
            return { dismissed: false, completed: false, shownCount: 0 };
        }
        const parsed = JSON.parse(raw);
        return {
            dismissed: Boolean(parsed?.dismissed),
            completed: Boolean(parsed?.completed),
            shownCount: Math.max(0, Math.floor(Number(parsed?.shownCount) || 0)),
        };
    } catch {
        return { dismissed: false, completed: false, shownCount: 0 };
    }
}

export function saveReviewPromptState(state = {}) {
    const next = {
        dismissed: Boolean(state.dismissed),
        completed: Boolean(state.completed),
        shownCount: Math.max(0, Math.floor(Number(state.shownCount) || 0)),
    };
    try {
        window.localStorage.setItem(LS_REVIEW_PROMPT_KEY, JSON.stringify(next));
    } catch {
        // ignore
    }
    return next;
}

export function shouldOfferReviewPrompt({
    storyWins = 0,
    reviewState = null,
} = {}) {
    const state = reviewState || loadReviewPromptState();
    if (state.dismissed || state.completed) {
        return false;
    }
    if (state.shownCount >= 2) {
        return false;
    }
    return Number(storyWins) >= 3;
}
